import { render, staticRenderFns } from "./orderOverDetails.vue?vue&type=template&id=3608353f&scoped=true&"
import script from "./orderOverDetails.vue?vue&type=script&lang=js&"
export * from "./orderOverDetails.vue?vue&type=script&lang=js&"
import style0 from "./orderOverDetails.vue?vue&type=style&index=0&id=3608353f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3608353f",
  null
  
)

export default component.exports